import type { FC } from 'react';

type HeadingProps = {
	as?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
	mode?: 'primary' | 'secondary' | 'tertiary';
	className?: string;
	children: React.ReactNode;
};

export const Heading: FC<HeadingProps> = ({ as: Tag = 'h2', mode = 'secondary', className = '', children }) => {
	const baseStyles = '';
	const modeStyles = {
		primary: 'text-6xl dark:text-gray-100 text-gray-900',
		secondary: 'text-3xl dark:text-gray-200 text-gray-900',
		tertiary: 'text-lg font-extrabold dark:text-gray-200 text-gray-700',
	}[mode];

	return <Tag className={` ${baseStyles} ${modeStyles} ${className}`}>{children}</Tag>;
};
